
new Swiper('.buly-category-carousel', {
    slidesPerView: 1.25,
    spaceBetween: 15,
    watchSlidesProgress: true,
    breakpoints: {
      450: {
        slidesPerView: 2.25,
        spaceBetween: 20
      },
      750: {
        slidesPerView: 3.5,
        spaceBetween: 20
      }
    },
    scrollbar: {
      el: '.swiper-scrollbar',
      draggable: true,
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
});